import type { IDataViewFilters } from '@/domains/investor/components/DataView/DataViewFilters/DataViewFilters.types'
import { useDataView } from '@/domains/investor/components/DataView/DataView.composable'

export const useReports = async (
  filters: MaybeRefOrGetter<IDataViewFilters>,
  page: MaybeRefOrGetter<number>,
  perPage: number,
  cacheKey = 'investor-reports',
) => {
  const { useList } = useDataView()

  const { items: reports, columns: reportsColumns, total, isLoading } = await useList({
    cacheKey,
    filters,
    page,
    perPage,
    baseKey: 'investor.reports.dataView',
    linkTextKey: 'investor.reports.dataView.table.link.text',
  })

  return {
    reports,
    reportsColumns,
    total,
    isLoading,
  }
}
